import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { fetchAuthSession } from "@/api-queries/auth";

export const Route = createFileRoute("/dashboard/admin")({
  beforeLoad: async () => {
    const session = await fetchAuthSession();
    if (!session?.user) throw redirect({ to: "/login" });
    if (session.user.role !== "admin") throw redirect({ to: "/dashboard" });
    return { session };
  },
  component: AdminLayout,
});

function AdminLayout() {
  return (
    <div className="mx-auto w-full max-w-6xl">
      <Outlet />
    </div>
  );
}
